import moment from 'moment'
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import minBy from 'lodash/minBy';


import { setReservationDates } from '../reservation.actions'
import { formatName, postData } from '../../utils/spaUtils'

export const processResrveDates = (items, cart, dispatch) => {
    let { appointment = [] } = items.reqAvailServMultiDayResult.appointments.appointment
    if (appointment.length === 0)
        return [];
    //Injecting Items in cart as its not available from API
    let _serviceIncart = cart.filter((cartItem) => appointment[0].treatmentId === cartItem.treatmentId);
    appointment = [...appointment, ..._serviceIncart];
    let sortedApp = sortBy(appointment, 'serviceTime');
    //Formatting
    let _appointmets = sortedApp.map((appointment) => {
        let formattedTime = moment(appointment.serviceTime, 'HHmm').format('LT')
        if (formattedTime === 'Invalid date')
            formattedTime = moment('0' + appointment.serviceTime, 'HHmm').format('LT')
        let formattedDate = moment(appointment.serviceDate, 'YYYYMMDD').format('ddd,  MMM Do')
        let formatDate = moment(appointment.serviceDate, 'YYYYMMDD').format(' MMM DD')
        return { ...appointment, formattedTime, formattedDate, formatDate }
    });
    //Grouped with date
    let appointmentsGrouped = groupBy(_appointmets, 'serviceDate')
    let appointments = Object.keys(appointmentsGrouped).map((key) => {
        let minPrice = minBy(appointmentsGrouped[key], (item) => item.treatmentPrice)
            .treatmentPrice
        return { ...appointmentsGrouped[key], minPrice, dateOfService: key }
    });
    dispatch(setReservationDates(appointments));
}

export const checkConflicts = (state, service) => {
    let { reservedServices = [], selectedGuestDetails } = state.services
    let { cart = [] } = state.reservations
    let allReservations = [...cart, ...reservedServices]
    if (service.serviceGroup === "relaxationareas")
        return false;

    service.serviceTime = (moment(service.serviceTime, 'HHmm').format('hhmm') === "Invalid date") ? `0${service.serviceTime}` : service.serviceTime;
    if (allReservations && allReservations.length > 0) {
        let conflict = allReservations.find((appointment) => {
            let appointmentDate = appointment.serviceDate || appointment.appointment.ServiceDate
            let paxId = appointment.PaxId || appointment.paxId

            let appointmentStartTime = appointment.serviceDate
                ? `${appointment.serviceDate}${appointment.serviceTime}`
                : `${appointment.appointment.ServiceDate}${appointment.appointment.ServiceTime}`
            let duration = appointment.duration || appointment.appointment.Duration
            // eslint-disable-next-line eqeqeq
            if (paxId == selectedGuestDetails.PaxId && appointmentDate == service.serviceDate) {
                let startTime = moment(appointmentStartTime, 'YYYYMMDDHHmm')
                let endTime = moment(appointmentStartTime, 'YYYYMMDDHHmm').add(duration, 'minutes')
                let appointmentRange = moment.range(startTime, endTime)

                let serviceStartTime = moment(
                    `${service.serviceDate}${service.serviceTime}`,
                    'YYYYMMDDHHmm'
                )
                let serviceEndTime = moment(
                    `${service.serviceDate}${service.serviceTime}`,
                    'YYYYMMDDHHmm'
                ).add(service.duration, 'minutes')
                let serviceRange = moment.range(serviceStartTime, serviceEndTime)
                window.moment = moment;
                let isBetween = appointmentRange.overlaps(serviceRange);// true

                // serviceTime.isBetween(startTime,endTime, null,'[]' )
                return isBetween
            }
            return false
        })
        if (conflict) {
            let userName = selectedGuestDetails.PassengerDetail.Name
            let _label = formatName(`${userName.FirstName} ${userName.LastName}`)
            let conflictMsg = `${_label} already has an appointment for selected time`
            return conflictMsg
        }
    }
    return false
}

export const getDayConflicts = (date, services, reservations) => {

    if (!services.reservedServices || services.reservedServices.length === 0)
        return false

    let servicesForPax = services.reservedServices.filter(
        (appointment) =>
            appointment.paxId === services.selectedGuestDetails.PaxId &&
            // eslint-disable-next-line eqeqeq
            date[0].serviceDate == appointment.appointment.ServiceDate
    )

    if (servicesForPax && servicesForPax.length > 0) {
        let passengerName = servicesForPax[0].PassengerDetail.Name
        let nameLabel = formatName(`${passengerName.FirstName} ${passengerName.LastName}`)
        let conflictMsg = `${nameLabel} already has appointments at `
        let ConflictsTimes = servicesForPax.map((app) => app.appointment.formatedTime).join(', ')
        conflictMsg = conflictMsg + ConflictsTimes
        return conflictMsg
    }

    return false
}

export const cartExtendAllPosts = (cart, extndUrl, state) => {
    let { services } = state;
    return cart.map((cartItem) => {
        console.log(cartItem)
        let _reqBody = {}
        _reqBody.Service = cartItem.treatmentId
        _reqBody.ResHoldId = cartItem.resHoldId
        _reqBody.passengerID = cartItem.PaxId
        _reqBody.paxFirstName = cartItem.PassengerDetail.Name.FirstName
        _reqBody.paxLastName = cartItem.PassengerDetail.Name.LastName
        _reqBody.VesselID = services.bookingDetails.vesselId
        _reqBody.paxCabin = ''
        _reqBody.PartnerId = 'PCL'
        return postData(extndUrl, _reqBody)
    });
}
